import { Icon, InlineExternalLink } from '@monash/portal-react';
import ParkType from '../park-type/ParkType';
import c from './multiple-carparks.module.scss';
import { SEARCH_TERM_MAP } from '../constants';

const MultipleCarparks = ({ groupedCarparks }) => {
  return (
    <>
      <div className={c.wrapper} data-testid="multiple-carparks">
        {groupedCarparks.map((group) => {
          const firstPermit = group?.carparks?.[0];
          const mapUrl = firstPermit?.mapUrl;
          const name = firstPermit?.name;

          const availableText = group?.carparks?.reduce((acc, curr) => {
            return `${acc} ${curr.vacancies} ${curr.colour
              .map((item) => SEARCH_TERM_MAP[item])
              .join(' and ')},`;
          }, '');

          return (
            <div key={group.name} className={c.item}>
              <div className={c.spaceBetween}>
                <b>{group.name}</b>
                <a
                  className={c.mapLink}
                  href={mapUrl}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={`Map link for ${name}, ${availableText} available. Opens in a new window.`}
                >
                  <Icon.External size={20} color="var(--card-cta-bg-color)" />
                </a>
              </div>

              {group.carparks.map((carpark) => {
                const isCombined = carpark?.colour.length > 1;
                const hasLiveData = !(carpark.accessibleSpaces && !isCombined);

                return (
                  <div key={carpark.id} className={c.spaceBetween}>
                    <div className={c.parkTypes}>
                      {carpark.colour.map((colour) => {
                        const spacesCount =
                          colour === 'Orange' ? carpark.accessibleSpaces : null;
                        return (
                          <ParkType
                            key={colour}
                            type={colour}
                            spacesCount={spacesCount}
                          />
                        );
                      })}
                    </div>
                    <div className={c.vacancyWrapper}>
                      {hasLiveData && (
                        <div className={c.number}>{carpark.vacancies}</div>
                      )}

                      <div className={c.subtext}>
                        {hasLiveData ? 'available' : 'No live data'}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}

        <div className={c.links}>
          <InlineExternalLink
            text="More parking information"
            link="https://www.monash.edu/about/our-locations/transport-parking/parking/staff-and-students#tabs__2341855-01"
          />

          <InlineExternalLink
            text="OPark app information"
            link="https://www.monash.edu/about/our-locations/transport-parking/parking/pay-as-you-use"
          />
        </div>
      </div>
    </>
  );
};

export default MultipleCarparks;
